// import 'jquery';
import $ from 'jquery';
import './jquery-global.js';
import 'bootstrap';
import 'slick-carousel';
import '@fancyapps/fancybox';


/////////////////////// HIDE NAVBAR DROPDOWNS WHEN ANOTHER DROPDOWN OPENED
// Nav Toggles
const searchToggle = document.querySelector("#search-toggle");
const basketToggle = document.querySelector("#basket-toggle");
const mainNavToggle = document.querySelector("#main-nav-toggle");

// Nav Dropdowns
const mainNavDropdown = document.querySelector("#main-nav-dropdown");
const basketDropdown = document.querySelector("#basket-dropdown");
const searchDropdown = document.querySelector("#search-dropdown");

// Show search dropdown
searchToggle.addEventListener('click', function () {
	basketDropdown.classList.remove('show');
	basketToggle.setAttribute('aria-expanded', 'false');
	mainNavDropdown.classList.remove('show');
	mainNavToggle.setAttribute('aria-expanded', 'false');
});

// Show basket dropdown
basketToggle.addEventListener('click', function () {
	searchDropdown.classList.remove('show');
	searchToggle.setAttribute('aria-expanded', 'false');
	mainNavDropdown.classList.remove('show');
	mainNavToggle.setAttribute('aria-expanded', 'false');
});

// Show main dropdown
mainNavToggle.addEventListener('click', function () {
	searchDropdown.classList.remove('show');
	searchToggle.setAttribute('aria-expanded', 'false');
	basketDropdown.classList.remove('show');
	basketToggle.setAttribute('aria-expanded', 'false');
});

/////////////////////// HIDE MOBILE FILTERS WHEN ANOTHER FILTER OPENED
const dropdownButtons = $(".mobile-filter-dropdown");

dropdownButtons.on('click', function (event) {
	dropdownButtons.each(function(index, element) {
		if(element != event.currentTarget) {
			$(element).attr('aria-expanded', 'false');
			$(element).parent().next('.collapse').removeClass('show');
		}
	});
});

/////////////////////// CLOSE FILTER DROPDOWNS ON CANCEL BUTTON CLICK
const cancelBtn = $(".cancel-btn");
cancelBtn.on('click', function () {
	$("#sort-dropdown").dropdown('toggle');
	$("#filter-dropdown").dropdown('toggle');
})

/////////////////////// FANCYBOX
// Favourites Modal
$('[data-fancybox="favourites-modal"]').fancybox({
	parentEl: "#favourites-modal-container",
	arrows: false
});

const favouritesIcon = $('a[data-src="#favourites-modal"] span:first-child');

// Change the icon to be solid when the favourites modal is displayed and close modal when icon is clicked again.
$(document).on('afterShow.fb', function( e, instance, slide ) {
	const favouritesTrigger = $('a[data-fancybox="favourites-modal"]');
	$(favouritesIcon).removeClass('icon-heart-o');
	$(favouritesIcon).addClass('icon-heart');
	$(favouritesTrigger).on('click', function(e) {
		instance.close();
	});
});

// Change the icon to outline when the favourites modal is closed
$(document).on('afterClose.fb', function( e, instance, slide ) {
	$(favouritesIcon).removeClass('icon-heart');
	$(favouritesIcon).addClass('icon-heart-o');
});


// Hide nav dropdown if user clicks on favourites toggle within the dropdown
$('[data-fancybox-trigger="favourites-modal"]').on('click', function () {
	mainNavDropdown.classList.remove('show');
	mainNavToggle.setAttribute('aria-expanded', 'false');
});


/////////////////////// STOP BACKGROUND SCROLLING WHEN FILTER DROPDOWNS EXPANDED
const sortBtn = $("#sort-dropdown");
const filterBtn = $("#filter-dropdown");

sortBtn.on('show.bs.dropdown', function () {
	document.body.style.position = 'fixed';
})
filterBtn.on('show.bs.dropdown', function () {
	document.body.style.position = 'fixed';
})

sortBtn.on('hide.bs.dropdown', function () {
	document.body.style.position = '';
})
filterBtn.on('hide.bs.dropdown', function () {
	document.body.style.position = '';
})


/////////////////////// SLIDERS
// Home Page Hero Slider
$('.hero-slider').slick({
	arrows: false,
	dots: true,
	autoplay: true,
	speed: 1000,
	autoplaySpeed: 5000
});

// Home Page Product Slider
$('.product-slider').slick({
	centerMode: true,
	centerPadding: '40px',
	arrows: false,
	slidesToShow: 2,
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2
			}
		},
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 1
			}
		}
	]
});

// Product Page Main Slider
$('.item-image-slider').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: true,
	centerMode: true,
	asNavFor: '.item-image-slider-nav',
	responsive: [
		{
			breakpoint: 576,
			settings: {
				asNavFor: null,
				dots: true
			}
		}
	]
});

// Product Page Slider Nav Images
$('.item-image-slider-nav').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	asNavFor: '.item-image-slider',
	dots: false,
	arrows: true,
	focusOnSelect: true
});

/* global $, site_url, grecaptcha */
import './jquery-global.js';
import 'bootstrap';
import 'slick-carousel';
import '@fancyapps/fancybox';
import fitvids from 'fitvids';

// Make all videos responsive
fitvids();

//// MOBILE NAV
var mobileNav_btn = $(".navbar .hamburger"),
	navbar = $(".navbar");

$(document).on('click', ".navbar .hamburger", function (e) {
	e.preventDefault();
	if (mobileNav_btn.hasClass("is-active")) {
		// Menu is open
		mobileNav_btn.removeClass("is-active");
		navbar.removeClass("nav-open");
	}
	else {
		// Menu is closed
		mobileNav_btn.addClass("is-active");
		navbar.addClass("nav-open");
	}
});

//// SEARCH TOGGLE
var search_toggle = $('.search-toggle');
$(document).on('click', '.search-toggle', function (e) {
	e.preventDefault();
	if (search_toggle.hasClass("is-active")) {
		// Search is open
		search_toggle.removeClass("is-active");
		navbar.removeClass("search-open");
	}
	else {
		// Search is closed
		search_toggle.addClass("is-active");
		navbar.addClass("search-open");
	}
});

//// FIELDS & LABELS

var field,
	field_block;

//// Float Labels

// Add focus class to filled fields on page load
$(function () {
	$('.float-label input').filter(function () {
		if (this.value.length > 0) {
			$(this).closest(".float-label").addClass("focus");
		}
	});
});

// When field is focussed
$(document).on("focus", ".float-label .form-control", function () {
	field = $(this);
	field_block = field.closest(".float-label");
	if (!field.prop('disabled')) {
		field_block.addClass("focus");
	}
});

// When field loses focus
$(document).on("blur", ".form-control", function () {
	field = $(this);
	field_block = field.closest(".float-label");
	if (field.val().length === 0) {
		field_block.removeClass("focus");
	}
});

//// MODAL
var modal;
function setModal(type, title, body) {
	modal.find('.modal-content').removeClass().addClass('modal-content ' + type);
	if (title !== '') {
		modal.find('.modal-title').html(title);
	}
	if (body !== '') {
		modal.find('.modal-body').html(body);
	}
}
function showModal(type, title, body) {
	setModal(type, title, body);
	modal.modal('show');
}

// Open a different modal from a link in a modal
// The link must have a data-target attribute with the #ID of the replacement modal
$(document).on('click', '.modal .modal-switch', function () {
	var this_modal = $(this).closest('.modal');
	var new_modal = $($(this).data('target'));

	new_modal.modal('show');
	this_modal.modal('hide');

	return false;
})

//// FORM SUBMISSIONS
/*----------------------------------------------------------------------------*/
var btn,
	form,
	formdata,
	feedback,
	error_msg;

$(document).on("submit", ".tr_form", function (e) {
	e.preventDefault();
	form = $(this);
	btn = form.find('button[type=submit]');
	modal = form.find('.modal');
	feedback = form.find('.feedback');
	error_msg = false;

	//Capture new form data
	formdata = form.serializeArray();
	formdata.push({
		"name": "submit",
		"value": 1
	});

	$(".formdata").each(function () {
		if ($(this).attr("type") === 'checkbox') {
			if ($(this).prop("checked") === true) {
				formdata.push({
					"name": this.name,
					"value": $(this).val()
				});
			}
		}
		else {
			formdata.push({
				"name": this.name,
				"value": $(this).val()
			});
		}
	});

	//Disable the save button and add "waiting" status
	btn.prop("disabled", true).addClass("running");
	//Remove error styling on all fields
	form.find(".field,.field input,.field textarea,.field select").removeClass("is-invalid").closest(".field").find('.invalid-feedback').remove();
	// Hide feedback alert (if present)
	feedback.hide();

	// Only continue if there is some form data
	if (formdata.length) {

		// Reformat the formdata array so we can read values by name
		var formddata_obj = {};
		$(formdata).each(function (i, field) {
			formddata_obj[field.name] = field.value;
		});

		// Only continue if the recaptcha key and action name exists
		if (formddata_obj.recaptcha_key) {

			// Get the recaptcha token and add it to the form data before submission
			grecaptcha.ready(function () {
				grecaptcha.execute(formddata_obj.recaptcha_key, { action: formddata_obj.form }).then(function (token) {

					// Add the token to the post data
					formdata.push({
						"name": "recaptcha_token",
						"value": token
					});

					// Submit the data
					$.ajax({
						url: site_url + 'site/ajax/form-process.php',
						type: 'post',
						data: formdata,
						dataType: "json"
					})
						.done(function (data) {
							if (data.success) {
								//Enable save button
								setTimeout(function () {
									btn.prop("disabled", false).removeClass("running");
								}, 1000);

								//Display success message
								if (data.modal_feedback) {
									showModal('success', data.success_header, data.success);
								}
								else {
									feedback.removeClass('error').addClass('success');
									feedback.html('<h4 class="alert-heading">' + data.success_header + '</h4><p>' + data.success + '</p>').slideDown();
								}


								//Reset the form
								form.trigger("reset");

								form.find(".field").removeClass("focus").removeClass("is-invalid").val(null);

								form.find("select[multiple]").val(null).trigger('change');
							}
							else {
								if (!$.isEmptyObject(data.errors)) {
									$.each(data.errors, function (i, val) {
										// If the key is 'dummy' show a general error
										if (i === 'dummy') {
											error_msg = val;
										}
										// If the key matched a field name, highlight the field and show the error underneath
										else {
											form.find(".field [name='" + i + "'],.field [name='" + i + "[]']")
												.addClass("is-invalid")
												.closest(".field")
												.addClass("is-invalid")
												.append('<p class="invalid-feedback">' + val + '</p>');
										}
									});
									if (error_msg) {
										if (data.modal_feedback) {
											showModal('error', data.error_header, error_msg);
										}
										else {
											feedback.removeClass('success').addClass('error');
											feedback.html('<h4 class="alert-heading">' + data.error_header + '</h4><p>' + error_msg + '</p>').slideDown();
										}
									}
									else {
										if (data.modal_feedback) {
											showModal('error', data.error_header, 'We couldn\'t submit this form.  Please correct the marked fields and try again.');
										}
										else {
											feedback.removeClass('success').addClass('error');
											feedback.html('<h4 class="alert-heading">' + data.error_header + '</h4><p>We couldn\'t submit this form.  Please correct the marked fields and try again.</p>').slideDown();
										}
									}
								}
							}

							//Enable save button
							setTimeout(function () {
								btn.prop("disabled", false).removeClass("running");
							}, 1000);
						});
				});
			});
		}
		else {
			error_msg = 'The validation key is missing';
			if (feedback.length) {
				feedback.removeClass('success').addClass('error');
				feedback.html('<h4 class="alert-heading">There was a problem</h4><p>' + error_msg + '</p>').slideDown();
			}
			else {
				showModal('error', 'There was a problem', error_msg);
			}
			//Enable save button
			setTimeout(function () {
				btn.prop("disabled", false).removeClass("running");
			}, 1000);
		}
	}
});

//// "LOAD MORE" BUTTONS
$(document).on("click",".btn-load-more",function(){
	var btn = $(this);
	var target = btn.data('target');
	var sectionId = btn.data('section');
	var filters = btn.data('filters');
	var skip = btn.data('skip');
	
	btn.addClass('running').prop('disabled',true);

	$.ajax({
			type: 'POST',
			url: theme_url+'ajax/product-cards-pager.php',
			data: {
					"section_id": sectionId,
					"filters": filters,
					"skip": skip
			}
	})
	.done(function(data) { 
			if(data !== '') {
					$("#"+target).append(data);
					var new_count = $("#"+target+" .card").length;
					btn.data('skip',new_count)
							.attr("data-skip",new_count)
							.prop('disabled',false);
					var btnContainer = btn.closest('.container');
					$("#"+target).append(btnContainer);
					 btn.removeClass('triggered');
			} else {
					btn.remove();
			}
			setTimeout(function(){
					btn.removeClass("running");
			},500);
	});
});

// Trigger the load more button automatically when scrolled into view
function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
	var $window = $(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = $(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

window.addEventListener('scroll', function() {
  // Pass element id/class you want to check
  if(!$('.btn-load-more').hasClass('triggered')) {
    if(isOnScreen( $('.btn-load-more') ) ) { 
      $('.btn-load-more').trigger('click').addClass('triggered');
    }	
  }
});


import './shop';
import './checkout';
import './feeds';